<template>
<div id="container" class="container maerchengeschichten">
  <div class="fullscreen_background">
    <img src="/static/assets/maerchengeschichten/Hintergrund_2860.jpg" />
  </div>

  <schnee :amount="500" :size="4" :speed="1.5" :wind="0" :opacity="0.8" :swing="1" :image="null" :zIndex="null" :resize="true" color="#fff" />
  <top-logo />
  <stoppuhr />
  <lautsprecher />
  <copyright />
  <top-menu />
  <hintergrundbutton />
  <!-- Figuren -->
  <div class="hexe hovering z4">
    <img src="/static/assets/maerchengeschichten/Hexe.png" class="img" />
  </div>
  <div class="prinzessin z4">
    <img src="/static/assets/maerchengeschichten/Prinzessin.png" class="img" />
  </div>
  <div class="koenig z4">
    <img src="/static/assets/maerchengeschichten/Koenig.png" class="img" />
  </div>
  <div class="koenigin z4">
    <img src="/static/assets/maerchengeschichten/Koenigin.png" class="img" />
  </div>
  <div class="prinz z4 hui_animation ">
    <!-- <img src="/static/assets/maerchengeschichten/Prinz.png" class="img" /> -->
  </div>
  <!-- <div class="buch z4">
        <img src="/static/assets/maerchengeschichten/Buch.png" class="img" />
    </div> -->
  <!-- <div class="schneemann z4">
        <img src="/static/assets/maerchengeschichten/Schneemann.png" class="img" />
    </div>
    <div class="schlitten z4">
        <img src="/static/assets/maerchengeschichten/Schlitten.png" class="img" />
    </div> -->
  <div class="pfeil_links_big z50">
    <img class="img" src="/static/assets/zaubergeschichten/Pfeil.png" />
  </div>
  <div class="libero z4">
    <img src="/static/assets/maerchengeschichten/Libero.png" class="img" />
  </div>
  <router-link to="/zaubergeschichten" tag="div" class="pfeil_links_big z50 pointer">
    <img class="img" src="/static/assets/zaubergeschichten/Pfeil.png" />
  </router-link>
  <router-link tag="div" to="piratengeschichten" class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/zaubergeschichten/Pfeil-1.png" />
    </router-link>
  <div class="geschichte z50">
    <img src="/static/assets/maerchengeschichten/Geschichte.png" usemap="#geschichte-map">
    <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Prinz_Hui.mp3" jsonurl="/static/assets/geschichten/hui.timings.json" content=".maerchengeschichten" target="maerchengeschichten_target" />
    <vuescrollbar tag="div" class="fliesstext" id="maerchengeschichten_target">
      <p>Es waren einmal eine Königin und ein König, die wünschten sich nichts mehr als ein Kind. Nach vielen, vielen Jahren kam eine Tochter zur Welt und überglücklich nannten sie das kleine Mädchen Gigi. </p>
      <p>Die Prinzessin lebte mit ihren Eltern auf Schloss Schönstein, das 7 Ballsäle, 77 Gärten und 777 Zimmer hatte. Überall durfte Gigi spielen und toben. Nur einen der Gärten durfte sie nicht betreten. Eine böse Zauberin hatte ihn verflucht und jedes
        Mädchen, das nur einen Fuß in ihn setzte, fiel in einen tiefen Schlaf, aus dem es nicht mehr erwachte.
        <p>So vergingen die Jahre und Gigi wuchs zu einem wunderschönen Mädchen heran. Eines Winternachmittags spazierte sie wie so oft durch die verschneiten Gärten. Plötzlich hörte sie hinter der hohen Hecke des verbotenen Gartens ein leises, elendes Wimmern.
          „Wer ist da? Kann ich helfen?“, rief Gigi besorgt. „Mein Bein, oh mein Bein!“, weinte es von drüben herüber. „Es steckt in einer Falle, ich verblute, ich verblute!“ Auwei! Gigi vergaß alle Bedenken und Verbote und lief los. Schon unter dem schneebedeckten
          Rosenbogen, der in den verwunschenen Garten führte, brach sie zusammen und fiel in einen tiefen Schlaf.</p>
        <p>Ojemine! Wie war der Jammer groß, als man die Prinzessin fand. „Hä, hä, hä“ lachte die Böse Zauberin im verbotenen Garten und kreischte hässlich:</p>
        <p>„Unterm Deckel bewahrt ein junger Mann den Schatz, der Gigi erwecken kann.“</p>
        <p>Auf Schloss Schönstein waren alle sehr, sehr traurig. Gigis Hausdrache Libero spuckte kein Feuer mehr und die Kamine blieben kalt. König Theo saß stumm auf seinem frostigen Thron und Königin Clara sponn mit klammen Fingern einen langen, nie endenden
          Faden, so endlos wie ihr Schmerz. Alle sehnten den jungen Mann herbei, der das Rätsel lösen und Gigi erwecken würde. Aus allen Ländern kamen sie angereist. Der reiche Ritter Kunibert ließ ins Zimmer der Prinzessin eine riesige, silberne Truhe
          tragen. Unter ihrem Deckel bewahrte er seine wertvollsten Edelsteine auf. Ein bettelarmer Hofnarr namens Dubix brachte einen Suppentopf. Unter dessen Deckel schwappte ein letzter Schluck Kohlsuppe, das Wertvollste, was der Hofnarr hatte. Er
          machte seine besten Späße. Doch die Königstochter schlief weiter ihren tiefen Schlaf.</p>
        <p>Da ritt Prinz Hui in den Schlosshof ein. Aus seiner Satteltasche zog er ein zerlesenes Buch und ließ sich zur Prinzessin führen. Er setzte sich neben sie, öffnete den Deckel seines Lieblingsbuches und las ihr vor. Da erwachte Gigi langsam. Wie
          freuten sich alle! Juchhe! Hofnarr Dubix schlug sogar einen Purzelbaum vor Glück. </p>
        <p>Von da an waren Hofnarr Dubix, Prinz Hui und Prinzessin Gigi Freunde fürs Leben. Der König aber schickte Boten durch das ganze Land. Sie verkündeten das Wiedererwachen der Prinzessin und die wichtige königliche Botschaft:</p>
        <p>Juchheissassa! <span>Das Lesen ist schön!</span></p>
    </vuescrollbar>
  </div>
</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
/* eslint whitespace: "off" */
/* eslint indent: "off" */
/* eslint keyword-spacing: "off" */


import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
import Snowf from 'vue-snowf'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'Maerchengeschichten',
  data () {
    return {
      who: 'Maerchengeschichten'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'lautsprecher': Lautsprecher,
    'player': Player,
    'copyright': Copyright,
    'schnee': Snowf,
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  mounted () {
    this.$ga.page(this.$router)
    var muted = (typeof this.$root.muted === 'undefined'? false : this.$root.muted)
    setTimeout(function () {
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Archivseite_Hui_Titel.mp3')
      window.currentAudioX.muted = (typeof window.muted !== 'undefined' ? window.muted : false)
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }

      window.hintergrundSound = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Maerchen_Atmo_pur.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined' ? window.muted : false)
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e) {
        window.bgsounddisabled = true
      }
    }, 1000)
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
      console.log('hintergrundsound nicht aktiv')
    }

  }
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

/* Z-Index - Level */

.z1 {
  z-index: 10;
}

.z2 {
  z-index: 20;
}

.z3 {
  z-index: 30;
}

.z4 {
  z-index: 40;
}

.z5 {
  z-index: 50;
}

.z6 {
  z-index: 60;
}

.z7 {
  z-index: 70;
}

.z8 {
  z-index: 80;
}

.z9 {
  z-index: 90;
}

.z10 {
  z-index: 100;
}

.z11 {
  z-index: 110;
}

.z12 {
  z-index: 120;
}

.z13 {
  z-index: 130;
}

.z14 {
  z-index: 140;
}

.z15 {
  z-index: 150;
}

.z16 {
  z-index: 160;
}

.z17 {
  z-index: 170;
}

.z18 {
  z-index: 180;
}

.z19 {
  z-index: 190;
}

.z20 {
  z-index: 200;
}

.z21 {
  z-index: 210;
}

.z22 {
  z-index: 220;
}

.z23 {
  z-index: 230;
}

.z24 {
  z-index: 240;
}

.z25 {
  z-index: 250;
}

.z26 {
  z-index: 260;
}

.z27 {
  z-index: 270;
}

.z28 {
  z-index: 280;
}

.z29 {
  z-index: 290;
}

.z30 {
  z-index: 300;
}

.z31 {
  z-index: 310;
}

.z32 {
  z-index: 320;
}

.z33 {
  z-index: 330;
}

.z34 {
  z-index: 340;
}

.z35 {
  z-index: 350;
}

.z36 {
  z-index: 360;
}

.z37 {
  z-index: 370;
}

.z38 {
  z-index: 380;
}

.z39 {
  z-index: 390;
}

.z40 {
  z-index: 400;
}

.z41 {
  z-index: 410;
}

.z42 {
  z-index: 420;
}

.z43 {
  z-index: 430;
}

.z44 {
  z-index: 440;
}

.z45 {
  z-index: 450;
}

.z46 {
  z-index: 460;
}

.z47 {
  z-index: 470;
}

.z48 {
  z-index: 480;
}

.z49 {
  z-index: 490;
}

.z50 {
  z-index: 500;
}

/*maerchengeschichten */

.maerchengeschichten {
  position: absolute;
  width: 1920px;
  height: 1080px;
  bottom: 0;
}

.maerchengeschichten .himmel {
  display: block !important;
}

.maerchengeschichten .geschichte {
  position: absolute;
  top: 170px;
  left: 47%;
}

.maerchengeschichten .libero {
  position: absolute;
  bottom: 2vh;
  left: 39.393939393939%;
}

.maerchengeschichten .buch {
  position: absolute;
  bottom: 6vh;
  left: 22.393939393939%;
}

.maerchengeschichten .prinzessin {
  position: absolute;
  top: 46.018519%;
  left: 24.747474747475%;
}

.maerchengeschichten .prinzessin {
  animation: prinzessin_erscheint 0.5s ease-out;
  animation-delay: 1s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
}

@keyframes prinzessin_erscheint {
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.maerchengeschichten .koenig {
  position: absolute;
  top: 55.018519%;
  left: 32.828282828283%;
}

.maerchengeschichten .koenig {
  animation: koenig_erscheint 0.5s ease-out;
  animation-delay: 2s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
}

@keyframes koenig_erscheint {
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.maerchengeschichten .koenigin {
  position: absolute;
  top: 55.018519%;
  left: 44.69696969697%;
}

.maerchengeschichten .koenigin img {
  animation: koenigin_erscheint 1s;
  animation-delay: 3s;
  animation-fill-mode: forwards;
  transform-origin: bottom center;
  /* margin-left: 100px; */
  opacity: 0;
}

@keyframes koenigin_erscheint {
  /* 0% {
    margin-left: 100px;
    opacity: 0;
  }
  100% {
    margin-left: 0;
    opacity: 1;
  } */
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.maerchengeschichten .hexe {
  position: absolute;
  top: 18.018519%;
  left: 38.545455%;
}

.maerchengeschichten .hexe img {
  animation: hexe_erscheint 15s ease-out;
  animation-delay: 0.75s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
  margin-left: 1070px;
}

@keyframes hexe_erscheint {
  0% {
    margin-left: 1070px;
    opacity: 0;
  }
  25% {
    opacity: 1;
    margin-top: 0px;
  }
  60% {
    margin-top: -150px;
  }
  100% {
    margin-left: 0px;
    opacity: 1;
    margin-top: 0px;
  }
}

.maerchengeschichten .prinz {
  position: absolute;
  top: 61.018519%;
  left: 13.131313131313%;
}

.maerchengeschichten .schneemann {
  position: absolute;
  top: 66.018519%;
  left: 89.131313%;
}

.maerchengeschichten .schlitten {
  position: absolute;
  top: 57.018519%;
  left: 91.131313%;
}

.fliesstext {
  bottom: 26%;
  left: 13.5%;
  width: 79%;
  font-size: 16pt;
  font-family: 'Open Sans';
  font-weight: 400;
  position: absolute;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 450px;
  padding-right: 15px;
}

/* möve animation */

@-webkit-keyframes hovering2
/* Safari and Chrome */

  {
  0% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  50% {
    -ms-transform: translate(0px, 50px);
    -moz-transform: translate(0px, 50px);
    -webkit-transform: translate(0px, 50px);
    -o-transform: translate(0px, 50px);
    transform: translate(0px, 50px);
  }
  100% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}

@keyframes hovering2 {
  0% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  /* 25% {
    -ms-transform: translate(-20px,20px);
    -moz-transform: translate(-20px,20px);
    -webkit-transform: translate(-20px,20px);
    -o-transform: translate(-20px,20px);
    transform: translate(-20px,20px);
  }
 */
  50% {
    -ms-transform: translate(0px, 50px);
    -moz-transform: translate(0px, 50px);
    -webkit-transform: translate(0px, 50px);
    -o-transform: translate(0px, 50px);
    transform: translate(0px, 50px);
  }
  /*  75% {

    -ms-transform: translate(20px,50px);
    -moz-transform: translate(20px,50px);
    -webkit-transform: translate(20px,50px);
    -o-transform: translate(20px,50px);
    transform: translate(20px,50px);
  }
*/
  100% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}

.maerchengeschichten .hovering {
  -webkit-animation: hovering2 8s ease-in-out infinite;
  -moz-animation: hovering2 8s ease-in-out infinite;
  -ms-animation: hovering2 8s ease-in-out infinite;
  -o-animation: hovering2 8s ease-in-out infinite;
  animation: hovering2 8s ease-in-out infinite;
}

.snowf-canvas[data-v-107894b6] {
  position: absolute;
  left: 0;
  top: 0;
  width: 150%;
  height: 150%;
  left: -25%;
  z-index: 30 !important;
}

.hui_animation {
  width: 450px;
  height: 409px;
  background: url('/static/assets/maerchengeschichten/hui_sprite_web.png') top center;
  animation-delay: 2s;
  animation: play_hui 7s steps(17) infinite;
  transform: scale(0.85);
  margin-top: -65px;
}

@keyframes play_hui {
  100% {
    background-position: 0 -7650px;
  }
}

::-webkit-scrollbar {
  width: 15px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 0px #ac8a69;
  box-shadow: inset 0 0 0px #ac8a69;
  -webkit-border-radius: 0;
  border-radius: 0;
}

::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: #ac8a69;
}

::-webkit-scrollbar-thumb:window-inactive {
  background: #ac8a69;
}

::-webkit-scrollbar-button {
  background: none;
}

::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat;
}

span {
  font-family: FrozenMemory;
}

.geschichte .player {
  left: 110px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Maerchengeschichten.vue